export default "__VITE_ASSET__99f68339__"